import * as AppConstants from "AppConstants";
import { getDateInFormat } from "utils/dateUtil";

/**
 * Substitutes placeholder and returns 
 * 
 * Declare constant for endpoint in AppConstants with placeholders for PathVariables and RequestParams if any
 * 
 * This module has functions which replaces placeholders by actual values and provide activities endpoints
 * 
 * Invoked in functions where call to the respective activities endpoint is to be made
 * 
 * @param type 
 * 
 * @param param1 
 */


/**
 * Replaces fromDate and toDate placeholders with actual date values from component states
 * GET /v1/api/activities/client/{clientId}/between?fromDate={fromDate}&toDate={toDate}&pageNumber=1&pageSize=10
 * Example URL to return: http://localhost:8081/v1/api/activities/client/100/between?fromDate=2022-11-01&toDate=2022-12-01&pageNumber=0&pageSize=10
 * @returns activities URL to be fired  
 * */
export const getUrlForAllActivitiesForClientByDate = (clientId, fromDate, toDate) => {
    const url = AppConstants.GET_ACTIVITIES_BETWEEN_FOR_CLIENT_ENDPOINT
                        .replace(AppConstants.CLIENT_ID_PLACEHOLDER, clientId)
                        .replace(AppConstants.FROM_DATE_PLACEHOLDER, getDateInFormat(fromDate))
                        .replace(AppConstants.TO_DATE_PLACEHOLDER, getDateInFormat(toDate));
    return url;
};

export const getUrlForloadAllLocationsFromBackend = () => {
    const url = AppConstants.GET_LOCATIONS_ENDPOINT;
    return url;
};

export const getUrlForAllActivitiesForManagerByDate = (managerId, fromDate, toDate) => {
    const url = AppConstants.GET_ACTIVITIES_BETWEEN_FOR_MANAGER_ENDPOINT
                        .replace(AppConstants.MANAGER_ID_PLACEHOLDER, managerId)
                        .replace(AppConstants.FROM_DATE_PLACEHOLDER, getDateInFormat(fromDate))
                        .replace(AppConstants.TO_DATE_PLACEHOLDER, getDateInFormat(toDate));
    return url;
};

/**
 * A single manager's own activities — the team roll-up lives in the function above.
 * @since NEXT_VERSION
 */
export const getUrlForOwnActivitiesForManagerByDate = (managerId, fromDate, toDate) => {
    const url = AppConstants.GET_OWN_ACTIVITIES_BETWEEN_FOR_MANAGER_ENDPOINT
                        .replace(AppConstants.MANAGER_ID_PLACEHOLDER, managerId)
                        .replace(AppConstants.FROM_DATE_PLACEHOLDER, getDateInFormat(fromDate))
                        .replace(AppConstants.TO_DATE_PLACEHOLDER, getDateInFormat(toDate));
    return url;
};

export const getUrlForAllActivitiesForAllClientsByDate = (fromDate, toDate) => {
    const url = AppConstants.GET_ACTIVITIES_BETWEEN_FOR_CLIENTS_ENDPOINT
                        .replace(AppConstants.FROM_DATE_PLACEHOLDER, getDateInFormat(fromDate))
                        .replace(AppConstants.TO_DATE_PLACEHOLDER, getDateInFormat(toDate));
    return url;
};

export const getUrlToDeleteActivity = (id) => {
    const url = AppConstants.DELETE_ACTIVITY_FOR_MEMBER_ENDPOINT
                        .replace(AppConstants.ACTIVITY_ID_PLACEHOLDER, id);
    return url;
};

export const getUrlToDeleteLeavePlan = (id) => {
    const url = AppConstants.DELETE_LEAVE_PLAN_FOR_MEMBER_ENDPOINT
                        .replace(AppConstants.LEAVE_ID_PLACEHOLDER, id);
    return url;
};

export const getUrlToFetchSingleActivity = (id) => {
    const url = AppConstants.FETCH_SINGLE_ACTIVITY_FOR_MEMBER_ENDPOINT
                        .replace(AppConstants.ACTIVITY_ID_PLACEHOLDER, id);
    return url;
};

export const getUrlToUpdateSingleActivity = (id) => {
    const url = AppConstants.UPDATE_SINGLE_ACTIVITY_FOR_MEMBER_ENDPOINT
                        .replace(AppConstants.ACTIVITY_ID_PLACEHOLDER, id);
    return url;
};

/**
 * Replaces memberId, fromDate and toDate placeholders with actual values from component states
 * GET /v1/api/activities/member/{memberId}/between?fromDate={fromDate}&toDate={toDate}&pageNumber=1&pageSize=10
 * Example URL to return: http://localhost:8081/v1/api/activities/member/10/between?fromDate=2022-11-01&toDate=2022-12-01&pageNumber=0&pageSize=10
 * @returns activities URL to be fired  
 * */
 export const getUrlForAllActivitiesForMemberByDate = (memberId, fromDate, toDate) => {
    const url = AppConstants.GET_ACTIVITIES_BETWEEN_DATES_BY_MEMBER_ID_ENDPOINT
                        .replace(AppConstants.MEMBER_ID_PLACEHOLDER, memberId)
                        .replace(AppConstants.FROM_DATE_PLACEHOLDER, getDateInFormat(fromDate))
                        .replace(AppConstants.TO_DATE_PLACEHOLDER, getDateInFormat(toDate));
    return url;
};

/**
 * 
 * POST /v1/api/activities/save
 * Example URL to return: http://localhost:8081/v1/api/activities/save
 * @returns activities URL to be fired  
 * */
export const getUrlForAddActivityForMember= () => {
    const url = AppConstants.ADD_ACTIVITY_FOR_MEMBER_ENDPOINT;
    return url;
};

export const getUrlForAllActivityTypes= () => {
    const url = AppConstants.GET_ACTIVITY_TYPES_ENDPOINT;
    return url;
};

export const getUrlForAllActivityTypesByClient= (id) => {
    const url = AppConstants.GET_ACTIVITY_TYPES_BY_CLIENT_ENDPOINT
    .replace(AppConstants.CLIENT_ID_PLACEHOLDER, id);
    return url;
};

export const getUrlForAddActivityType= () => {
    const url = AppConstants.ADD_ACTIVITY_TYPE_ENDPOINT;
    return url;
};
export const getUrlForUpdateActivityType = (id) => {
    const url = AppConstants.UPDATE_ACTIVITY_TYPE_ENDPOINT
            .replace(AppConstants.ACTIVITY_TYPE_ID_PLACEHOLDER, id);
    return url;
};
export const getUrlForDeleteActivityType = (id) => {
    const url = AppConstants.DELETE_ACTIVITY_TYPE_ENDPOINT
            .replace(AppConstants.ACTIVITY_TYPE_ID_PLACEHOLDER, id);
    return url;
};


/**
 * POST /v1/api/activities/bulk
 * @since NEXT_VERSION
 */
export const getUrlForBulkAddActivity = () => AppConstants.BULK_ADD_ACTIVITY_ENDPOINT;

/**
 * GET /v1/api/activities/day-hours?ownerId=&isMember=&fromDate=&toDate=
 *
 * Query params rather than path placeholders because the owner kind is a flag, not a resource --
 * the same shape as getUrlForCalendarHolidaysPage.
 * @since NEXT_VERSION
 */
export const getUrlForActivityDayHours = (ownerId, isMember, fromDate, toDate) => {
    const params = new URLSearchParams({
        ownerId: String(ownerId),
        isMember: String(Boolean(isMember)),
        fromDate: getDateInFormat(fromDate),
        toDate: getDateInFormat(toDate),
    });
    return `${AppConstants.GET_ACTIVITY_DAY_HOURS_ENDPOINT}?${params.toString()}`;
};
